"use client";
import { FC } from "react";
import s from "./table.module.css";

type Props = {
	data: any;
	columnsNames: any;
	bold?: boolean;
};

const Table1: FC<Props> = ({ data, columnsNames, bold }) => {
	const concatedData = columnsNames.concat(data);
	return (
		<div className=' border border-white rounded-[15px] overflow-hidden h-full mt-[50px]'>
			<div className={s.table1}>
				{concatedData.map((el: any, index: number) => (
					<div
						key={index}
						className={`border text-[30px] py-[10px] ${
							index <= 2 && "font-[600] "
						} ${bold && (index <= 2 || index % 3 === 0) && "font-[600] "} ${
							bold && index <= 2 && "py-[20px]"
						} max-desktop:text-[21px] max-tablet:text-[16px] max-tablet:leading-[14px] max-tablet:px-[5px] max-desktop:leading-[21px] leading-[29px] font-[300] text-center whitespace-pre-line flex items-center justify-center border-white px-[15px] `}>
						{index <= 2 ? el.columnName : el.text}
					</div>
				))}
			</div>
		</div>
	);
};

export default Table1;
